import {
	EDGE_REGION_HINT_HEADER,
	getEdgeRegionHint,
} from '@atlassian/search-common/get-edge-region-hint';

import type { BootstrapVariables } from '../../../common/constants/relay/types';

type getRelayFetchOptionsArgs = {
	primaryProduct: BootstrapVariables['primaryProduct'];
	productDataRegions: BootstrapVariables['productDataRegions'];
};

export function getRelayFetchOptions({
	primaryProduct,
	productDataRegions,
}: getRelayFetchOptionsArgs): {
	networkCacheConfig: {
		metadata: {
			headers: {
				[EDGE_REGION_HINT_HEADER]: string | undefined;
			};
		};
	};
} {
	const edgeRegionHint =
		primaryProduct && productDataRegions
			? getEdgeRegionHint(primaryProduct, productDataRegions)
			: undefined;

	return {
		networkCacheConfig: {
			metadata: {
				headers: {
					[EDGE_REGION_HINT_HEADER]: edgeRegionHint,
				},
			},
		},
	};
}
